import { render } from "./IconTextDown.vue?vue&type=template&id=8949d770"
import script from "./IconTextDown.vue?vue&type=script&lang=js"
export * from "./IconTextDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__